<template>
    <f-dialog
        v-if         = "audit"
        v-model      = "show"
        :width       = "1200"
        :show-header = "true"
        :hide-actions = "true"
        :title       = "$t('audit.delta.title', [ type, audit.date ])"
        @cancel      = "onCancel"
    >
        <template v-slot:content>
            <v-card
                class = "bg-white pa-2"
                flat
            >
                <div class="v-flex">
                    <div class="history-ident primary--text">
                        Benutzer
                    </div>
                    <div class="history-time primary--text">
                        Datum
                    </div>
                    <div class="history-catalogue primary--text">
                        ID
                    </div>
                    <div class="history-rating primary--text">
                        Bewertung
                    </div>
                    <div class="history-measure primary--text">
                        Maßnahme
                    </div>
                    <div class="history-costs primary--text" style="text-align: center" v-if="!isEscalator">
                        Schätzkosten
                    </div>
                    <div class="history-notice primary--text">
                        Notiz
                    </div>
                </div>
                <v-divider class="mt-1 mb-1" />
                <div class="history-scroll">
                    <div v-for="(entry, index) in history" :key="index">
                        <v-divider v-if="index !== 0 && history[index].catalogueId !== history[index-1].catalogueId" />
                        <div class="v-flex">
                            <div class="history-ident">
                                {{ entry.ident }}
                            </div>
                            <div class="history-time">
                                {{ formatTime (entry.timestamp) }}
                            </div>
                            <div class="history-catalogue">
                                {{ code(entry.catalogueId) }}
                            </div>
                            <div class="history-rating">
                                {{ entry.ratingName }}
                            </div>
                            <div class="history-measure">
                                {{ entry.measureName }}
                            </div>
                            <div class="history-costs" v-if="!isEscalator">
                                {{ formatMoney (entry.costs) }}
                            </div>
                            <div class="history-notice">
                                {{ entry.notice }}
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
        </template>
    </f-dialog>
</template>

<script>

import Audit from "@/modules/audit/service/Audit.js";
import FDialog from "@/modules/core/components/utils/FDialog.vue";
import Core from "@/modules/core/service/Core";
import AuditType, { ESCALATOR } from "@/modules/audit/service/AuditType";

export default {
    name: "PAuditHistory",

    props: {
        value: {
        },

        audit: {
        },

        type: {
        },

        /** GBU type of the audit (HCIT-917): escalator GBUs show the code (G42) and no costs. */
        deviceType: {
        }
    },

    components: {
        FDialog
    },

    data: () => ({
        show: false,
        history: [],
    }),

    computed: {
        isEscalator () {
            return this.deviceType === ESCALATOR;
        }
    },

    watch: {
        value () {
            this.show = this.value;
            if (this.show) {
                this.onLoad();
            }
        }
    },

    mounted() {
        this.show = this.value;
        this.onLoad();
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        onLoad () {
            if (!this.audit) {
                return;
            }

            Audit.finAuditHistory(this.audit).then(data => {
                this.history = data;
            });
        },

        /** The code of the catalogue entry (G42 for FG42); the history only has the catalogue id. */
        code (catalogueId) {
            if (!this.isEscalator || !this.audit || !this.audit.entries) {
                return catalogueId;
            }

            const entry = this.audit.entries.find(e => e.catalogue && e.catalogue.id === catalogueId);
            return entry ? AuditType.code(entry.catalogue) : catalogueId;
        },

        formatTime (value) {
            if (!value) {
                return "";
            }

            return Core.format.datetime.display(value);
        },

        formatMoney (value) {
            return Core.format.money (value);
        }
    }
}
</script>

<style scoped>

.history-scroll {
    max-height: 500px;
    overflow-y: auto;
}

.history-ident {
    min-width: 150px;
    max-width: 150px;
}

.history-time {
    min-width: 140px;
    max-width: 140px;
}

.history-catalogue {
    min-width: 60px;
    max-width: 60px;
}

.history-rating {
    min-width: 110px;
    max-width: 110px;
}

.history-measure {
    min-width: 280px;
    max-width: 280px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.history-costs {
    min-width: 110px;
    max-width: 110px;
    text-align: right;
    padding-right: 8px;
}

.history-notice {
    min-width: 280px;
    max-width: 280px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.history-ident, .history-time, .history-ident, .history-catalogue, .history-rating, .history-measure, .history-costs, .history-notice {
    height: 30px;
    vertical-align: middle;
    padding-top: 4px;
}

</style>
